import {
  FETCHING_USERS_REQUEST, FETCHING_USERS_SUCCEEDED, FETCHING_USERS_FAILED, INVALIDATE_USERS,
  UPDATE_USER_ACCESS_REQUEST, UPDATING_USER_ACCESS_SUCCEEDED, UPDATING_USER_ACCESS_FAILED,
  INVALIDATE_USER_ACCESS,

  FETCHING_INVITATIONS_REQUEST, FETCHING_INVITATIONS_SUCCEEDED, FETCHING_INVITATIONS_FAILED,
  INVITE_USER_REQUEST, INVITE_USER_SUCCEEDED, INVITE_USER_FAILED, INVALIDATE_INVITE_USER,
  UPDATE_INVITATION_ROLE, UPDATE_INVITATION_ROLE_SUCCEEDED, UPDATE_INVITATION_ROLE_FAILED,
  RESEND_USER_INVITATION, RESEND_USER_INVITATION_SUCCEEDED, RESEND_USER_INVITATION_FAILED,
  DELETE_USER_INVITATION, DELETE_USER_INVITATION_SUCCEEDED, DELETE_USER_INVITATION_FAILED
} from 'constants/actionTypes.jsx';

import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';

import buildUrl from 'build-url';

const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/2.0`;
const WORKSPACE_URL = `${apiUrl}/workspaces`;
const INVITATION_URL = `${process.env.REACT_APP_PAPERFLITE_API_URL}/api/2.0/invitations`;

/**
* Fetch all Users
*/
export const fetchAllUsers = createAction(FETCHING_USERS_REQUEST, (id, page, query) => {
  return {
    id: id,
    page: page,
    query: query
  }
});

const fetchAllUsersSucceeded = createAction(FETCHING_USERS_SUCCEEDED, (response) => {
  return response;
});

const fetchAllUsersFailed = createAction(FETCHING_USERS_FAILED, (error) => {
  return error;
});

function* fetchAllUsersSaga(action) {
  const { id, page, query } = action.payload;

  var params = {
    page: page,
    query: query
  }

  const fetchAllUsersAPI = (params) => {

    let url = buildUrl(WORKSPACE_URL, {
      path: `/${id}/users`,
    });

    return axios({
      method: 'GET',
      url: url,
      params: params
    }).then(response => response.data);
  }

  try {
    const response = yield call(fetchAllUsersAPI, params);
    yield put(fetchAllUsersSucceeded(response));
  } catch (error) {
    yield put(fetchAllUsersFailed(error));
  }
}

export const invalidateUsers = createAction(INVALIDATE_USERS);

/**
* ASSIGN ROLE FOR USER
*/
export const updateUserAccess = createAction(UPDATE_USER_ACCESS_REQUEST, (workspace, id, request) => {
  return {
    workspace: workspace,
    id: id,
    request: request
  };
})

const updateUserAccessSucceeded = createAction(UPDATING_USER_ACCESS_SUCCEEDED, (id, response) => {
  return {
    id, response
  };
})

const updateUserAccessFailed = createAction(UPDATING_USER_ACCESS_FAILED, (id, error) => {
  return {
    id, error
  };
})

function* updateUserAccessSaga(action) {
  const { workspace, id, request } = action.payload;
  
  let url = buildUrl(WORKSPACE_URL, {
    path: `/${workspace}/users/${id}`,
  });

  const updateUserAccessAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateUserAccessAPI);
    yield put(updateUserAccessSucceeded(id, response));
  } catch (error) {
    yield put(updateUserAccessFailed(id, error));
  }
}

export const invalidateUserAccess = createAction(INVALIDATE_USER_ACCESS);

/**
* Invite User
*/
export const inviteUser = createAction(INVITE_USER_REQUEST, (user) => {
  return user;
})

const inviteUserSucceeded = createAction(INVITE_USER_SUCCEEDED, (response) => {
  return response;
})

const inviteUserFailed = createAction(INVITE_USER_FAILED, (error) => {
  return error;
})

export const invalidateInviteUser = createAction(INVALIDATE_INVITE_USER);

function* inviteUserSaga(action) {
  const  user = action.payload;

  const inviteUserAPI = () => {

    let url = buildUrl(WORKSPACE_URL, {
      path: `/invitations`,
    });

    return axios.post(url, user).then(response => response.data);
  }

  try {
    const response = yield call(inviteUserAPI);
    yield put(inviteUserSucceeded(response));
  } catch (error) {
    yield put(inviteUserFailed(error));
  }

}

/**
* ASSIGN ROLE FOR INVITATION
*/
export const updateInvitationRole = createAction(UPDATE_INVITATION_ROLE, (workspace, id, request) => {
  return {
    workspace: workspace,
    id: id, 
    request: request
  }
});

const updateInvitationRoleSucceeded = createAction(UPDATE_INVITATION_ROLE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    invitation: response
  }
})

const updateInvitationRoleFailed = createAction(UPDATE_INVITATION_ROLE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* updateInvitationRoleSaga(action) {
  const { workspace, id, request } = action.payload;

  let url = buildUrl(WORKSPACE_URL, {
    path: `/${workspace}/invitations/${id}`,
  });

  const updateInvitationRoleAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(updateInvitationRoleAPI);
    yield put(updateInvitationRoleSucceeded(id, response));
  } catch (error) {
    yield put(updateInvitationRoleFailed(id, error));
  }
}

/**
* DELETE INVITATION
*/
export const deleteInvitation = createAction(DELETE_USER_INVITATION, (workspace, id) => {
  return {
    workspace: workspace,
    id: id
  };
})

const deleteInvitationSucceeded = createAction(DELETE_USER_INVITATION_SUCCEEDED, (id) => {
  return id;
})

const deleteInvitationFailed = createAction(DELETE_USER_INVITATION_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
})

function* deleteInvitationSaga(action) {
  const { workspace, id } = action.payload;

  let url = buildUrl(WORKSPACE_URL, {
    path: `/${workspace}/invitations/${id}`,
  });

  const deleteInvitationAPI = () => {
    return axios.delete(url).then(response => response.data);
  }

  try {
    const response = yield call(deleteInvitationAPI);
    yield put(deleteInvitationSucceeded(id));
  } catch (error) {
    yield put(deleteInvitationFailed(error));
  }
}

/**
* Resend Invitations
*/
export const resendInvitation = createAction(RESEND_USER_INVITATION, (workspace, id) => {
  return {
    workspace, id
  };
})

const resendInvitationSucceeded = createAction(RESEND_USER_INVITATION_SUCCEEDED, (id) => {
  return id;
})

const resendInvitationFailed = createAction(RESEND_USER_INVITATION_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  };
})

function* resendInvitationSaga(action) {
  const { workspace, id } = action.payload;

  let url = buildUrl(WORKSPACE_URL, {
    path: `/${workspace}/invitations/${id}/resend`,
  });


  const resendInvitationAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(resendInvitationAPI);
    yield put(resendInvitationSucceeded(id));
  } catch (error) {
    yield put(resendInvitationFailed(id, error));
  }
}


/**
* Fetch all Invitations
*/
export const fetchAllInvitations = createAction(FETCHING_INVITATIONS_REQUEST, (id, page, query) => {
  return {
    id: id,
    page: page,
    query: query
  }
});
const fetchAllInvitationsSucceeded = createAction(FETCHING_INVITATIONS_SUCCEEDED, (response) => {
  return response;
});
const fetchAllInvitationsFailed = createAction(FETCHING_INVITATIONS_FAILED, (error) => {
  return error;
});

function* fetchAllInvitationsSaga(action) {
  const { id, page, query } = action.payload;

  var params = {
    page: page,
    query: query
  }

  const fetchAllInvitationsAPI = (params) => {
    
    let url = buildUrl(WORKSPACE_URL, {
      path: `/${id}/invitations`,
    });

    return axios({
      method: 'GET',
      url: url,
      params: params
    }).then(response => response.data);

  }

  try {
    const response = yield call(fetchAllInvitationsAPI, params);
    yield put(fetchAllInvitationsSucceeded(response));
  } catch (error) {
    yield put(fetchAllInvitationsFailed(error));
  }
}

export default function* userManagementSaga() {
  yield takeLatest(FETCHING_USERS_REQUEST, fetchAllUsersSaga);
  yield takeLatest(UPDATE_USER_ACCESS_REQUEST, updateUserAccessSaga);

  yield takeLatest(INVITE_USER_REQUEST, inviteUserSaga);
  yield takeLatest(FETCHING_INVITATIONS_REQUEST, fetchAllInvitationsSaga);
  yield takeLatest(RESEND_USER_INVITATION, resendInvitationSaga);
  yield takeLatest(DELETE_USER_INVITATION, deleteInvitationSaga);
  yield takeLatest(UPDATE_INVITATION_ROLE, updateInvitationRoleSaga);
};